/**
 * This is the desktop bottom toaster that offers placing an email and
 * pressing the Get-Notified button
 */

import apiRequest from '@zr/utilities/api';

const statusProperties = {
  cssProperty: 'visibility',
  valueShow: 'visible',
  valueHide: 'hidden',
};
const emailSuccessfulRegAlertCookieKey = 'go-serp_email_reg_success_alert';

const initSerpPopover = () => {
  const $serpAlertModal = $('[data-modal-serp]');
  const showSerpModal = zr.page.model.shouldRenderRegModal;
  if (showSerpModal && $serpAlertModal.modal) {
    $serpAlertModal.modal('show');
    $.log_event('auto_modal_show', { name: 'alert_from_search_pop', version: 'default' });
  }
  const emailModalSerpCookieKey = 'go-serp_email_reg_modal_viewed';
  // Opt in to the modal close event
  $serpAlertModal.on('hide.bs.modal', () => {
    $.cookie(emailModalSerpCookieKey, 1, { expires: 1, path: '/' });
  });
  // If the email has successfully been registered, show alert msg
  const alertCookieValue = $.cookie(emailSuccessfulRegAlertCookieKey);
  if (alertCookieValue) {
    $('[data-email-success-alert]').css('display', 'block');
    $.cookie(emailSuccessfulRegAlertCookieKey, null, { expires: 1, path: '/' });
  }
  $serpAlertModal.on('submit', (e) => {
    e.preventDefault();
    $.cookie(emailSuccessfulRegAlertCookieKey, 1, { expires: 1, path: '/' });
  });
  // Use SERP-specific values for status properties
  statusProperties.cssProperty = 'display';
  statusProperties.valueShow = 'block';
  statusProperties.valueHide = 'none';
};

const initEmailPopover = () => {
  // The form structure is almost identical on mobile and desktop. On mobile it is just contained within a modal.
  const $emailPopover = $('[data-email-popover]');
  const $emailAlertPopoverForm = $('[data-email-popover-form]');
  const $emailAlertModal = $('[data-modal="email-alert"]');
  const $emailAlertOpen = $('[data-open-email-alert-modal]');
  const $emailAlertModalFormInput = $emailPopover.find('input[type="email"]');
  const zrisValidURLOrPath = (url) => url && (url.match(/^(https?:\/\/|\/)/i) ? 1 : 0);
  const $emailPopoverClose = $emailPopover.find('[data-email-popover-close]'); // This is the toaster close button
  // Close popover.
  $emailPopoverClose.on('click', () => {
    if (zr.page.model.emailPopoverCookieKey) {
      $.cookie(zr.page.model.emailPopoverCookieKey, 1, { expires: 1, path: '/' });
    }
    $emailPopover.removeClass('active');
  });
  const setErrorStatus = (message, targetForm) => {
    targetForm.find('[data-status]').text(message).css(statusProperties.cssProperty, statusProperties.valueShow);
    targetForm.find('button[type="submit"]').prop('disabled', 'true');
    targetForm.find('input[type="email"]').attr('aria-invalid', 'true').addClass('error').focus();
  };
  $emailAlertOpen.on('click', (e) => {
    const $emailAlertPopoverFormStatus = $emailPopover.find('[data-status]');
    $emailPopover.hide();
    // Reset status indicator.
    $emailAlertPopoverFormStatus.removeClass('zrs_spinner');
    $emailAlertPopoverFormStatus.text('');
    $emailAlertPopoverFormStatus.css(statusProperties.cssProperty, statusProperties.valueHide);
    // Show modal.
    const modalID = $(e.target).data('modal-id');
    if (modalID) {
      $(`#${modalID}`).attr('data-modal-state', 'initial-mobile').modal('show');
    }
  });
  $emailAlertPopoverForm.on('submit', async (event) => {
    const $emailAlertPopoverFormStatus = $(event.target).find('[data-status]');
    const $emailAlertModalFormSubmit = $(event.target).find('button[type="submit"]');
    event.preventDefault();
    $.log_event('button_click', { field: 'dirp_cta_continue' });
    $emailAlertPopoverFormStatus
        .text('')
        .css(statusProperties.cssProperty, statusProperties.valueShow)
        .addClass('zrs_spinner');
    $emailAlertModalFormSubmit.prop('disabled', true);
    try {
      await new Promise((res) => {
        setTimeout(() => {
          res();
        }, 2000);
      });
      $emailAlertModalFormSubmit.prop('disabled', true);
      $emailAlertPopoverFormStatus.css(statusProperties.cssProperty, statusProperties.valueHide);
      const response = await apiRequest('/candidate/create-from-search', {
        method: 'POST',
        body: $(event.target).serialize(),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
      });
      const json = await response.json();
      if (json.status === 'success') {
        if (zrisValidURLOrPath(json.redirect_url)) {
          window.location = json.redirect_url;
        } else {
          setErrorStatus('Login success. We were unable to refresh your page. Please refresh your page manually.', $(event.target));
        }
      } else if (json.error_type === 'email_exists') {
        $emailAlertModalFormSubmit.prop('disabled', true);
        $emailAlertPopoverFormStatus.css(statusProperties.cssProperty, statusProperties.valueHide);
        // While an email can exist, the user will be presented with different options dependent on
        // whether a password has been set or not
        if (json.si_password_type && json.si_password_type === 'system_generated') {
          // Password has been autogenerated by system
          // Show the "email exists" modal.
          if ($emailAlertModal) {
            $emailAlertModal.attr('data-modal-state', 'email-exists');
            $emailAlertModal.modal('show');
            $.log_event('failed_reg', { name: 'auto_banner_show' });
          }
        } else if (json.si_password_type) {
          // Password set by user or a google sign-in; ask them to login via the server-supplied redirect URL
          $.log_event('failed_reg', { name: 'password_exists_login_redirect' });
          window.location = json.redirect_url;
        }
      } else {
        // other error message
        setErrorStatus(json.message, $(event.target));
      }
    } catch (err) {
      setErrorStatus('Could not submit the form at this moment. Try again.', $(event.target));
    }
    $emailAlertPopoverFormStatus.removeClass('zrs_spinner');
    $emailAlertModalFormSubmit.prop('disabled', false);
  });
  $emailAlertModalFormInput.on('input', (e) => {
    $(e.target).removeClass('error');
    $(e.target).attr('aria-invalid', 'false');
  });
  $emailAlertModalFormInput.on('focus', (e) => {
    const $emailAlertTerms = $(e.target).closest('[data-email-popover]').find('[data-email-terms]');
    $emailAlertTerms.show();
  });
  $(document).on('google_one_tap_closed', () => {
    if (!zr.page.model.isLoggedIn) {
      $emailPopover.addClass('active');
    }
  });
};
export { initEmailPopover, initSerpPopover };
